import { render, staticRenderFns } from "./TheSnapshotRestore.vue?vue&type=template&id=48077b6a&"
import script from "./TheSnapshotRestore.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports